'use client';

import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import classNames from 'classnames';

import { PropsWithClassname } from '@/app/types';

import Image from 'next/image';

import dvtvLogo from '../../../public/public/images/logo-dvtv.svg';
import forbesLogo from '../../../public/public/images/logo-forbes.svg';
import ctvLogo from '../../../public/public/images/logo-ceskatelevize.svg';
import novaLogo from '../../../public/public/images/logo-nova.svg';
import bleskLogo from '../../../public/public/images/logo-blesk.svg';

const MediaPartners = ({ className }: PropsWithClassname) => {
  const { t } = useTranslation();

  const mediaPartners = useMemo(
    () => [
      {
        imageSrc: dvtvLogo,
        imageAlt: t('components.MediaPartners.dvtv'),
        link: 'https://youtu.be/o6IC4Ebe_1E?si=nwYWVMS8o2u_J5Bt',
      },
      {
        imageSrc: forbesLogo,
        imageAlt: t('components.MediaPartners.forbes'),
        link: 'https://forbes.cz/miliarda-dobra-donio-pokorilo-milnik-a-zvazuje-vstup-na-ukrajinu/',
      },
      {
        imageSrc: ctvLogo,
        imageAlt: t('components.MediaPartners.ceskaTelevize'),
        link: 'https://www.ceskatelevize.cz/porady/10435049455-dobre-rano/320291310020027/video/756944',
      },
      {
        imageSrc: novaLogo,
        imageAlt: t('components.MediaPartners.nova'),
        link: 'https://www.youtube.com/watch?v=JrQR4gFwFTM',
      },
      {
        imageSrc: bleskLogo,
        imageAlt: t('components.MediaPartners.blesk'),
        link: 'https://www.blesk.cz/clanek/zpravy-epicentrum/772311/zakladatel-donia-pres-pul-miliardy-za-rok-cesi-umi-sahnout-hluboko-do-kapsy-rok-od-roku-vic-a-vic.html',
      },
    ],
    [t],
  );

  return (
    <div className={classNames(className, 'flex justify-center lg:justify-between flex-wrap')}>
      {mediaPartners.map((partner) => (
        <a key={partner.link} href={partner.link} target="_blank" className="group block mt-[40px] mx-[24px] lg:mx-0">
          <Image
            src={partner.imageSrc}
            alt={partner.imageAlt}
            className="h-[26px] lg:h-[40px] w-auto transition-all group-hover:opacity-[0.6]"
          />
        </a>
      ))}
    </div>
  );
};

export default MediaPartners;
